import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule, MatFormFieldModule, MatInputModule, MatProgressSpinnerModule, MatRadioModule } from '@angular/material';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ValidateInputDirective } from '../../../directives/validate-input/validate-input.directive';
import { FileUploadCustomControlCustomControlComponent, InputCustomControlComponent, MatSelectCustomControlComponent, PasswordCustomControlComponent, RadioGroupCustomControlComponent, SelectCustomControlComponent, TextAreaCustomControlComponent } from './';

@NgModule({
  declarations: [FileUploadCustomControlCustomControlComponent, InputCustomControlComponent, PasswordCustomControlComponent, MatSelectCustomControlComponent,
    RadioGroupCustomControlComponent, SelectCustomControlComponent, TextAreaCustomControlComponent, ValidateInputDirective],
  imports: [CommonModule, FormsModule, ReactiveFormsModule,
    ScrollPanelModule, MatFormFieldModule, MatAutocompleteModule, MatInputModule, MatProgressSpinnerModule, MatRadioModule,
  ],
  exports: [FileUploadCustomControlCustomControlComponent, InputCustomControlComponent, PasswordCustomControlComponent, MatSelectCustomControlComponent,
    RadioGroupCustomControlComponent, SelectCustomControlComponent, TextAreaCustomControlComponent, ValidateInputDirective]
})
export class CustomFormControlsModule { }
